import dataModule from '@/store/modules/data'
import iquoteModule from '@/store/modules/iquote'
import b2bSpecificModule from '@/store/modules/b2bspecific'
import navigationSteps from '@/store/modules/navigationSteps'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    data: dataModule,
    iquote: iquoteModule,
    steps: navigationSteps,
    b2bIQuote: b2bSpecificModule,
  },
})
